import { useOrganization } from "../../../state/auth.reducer";
import { useAdminGetUserOrg } from "./useAdminGetUserOrg";
export var useAccordingOrganization = function (adminAccess, userId) {
    var regularOrg = adminAccess ? null : useOrganization();
    var adminUserOrg = useAdminGetUserOrg(userId, adminAccess);
    return adminAccess ? adminUserOrg : regularOrg;
};
